// services/PinSizeService.js

import { deepClean, encodeQueryData } from "@/utils/commonUtils";
import httpService from "./httpService";

export default {
    getAll: async (props) => {
        const params = encodeQueryData(deepClean(props));
        return await httpService.get('map/pin-sizes?'+params);
    },
}
